export const TrendUp = ({ width = 20, height = 20 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99997 8.414L12 12.414L17.707 6.707L20 9V3H14L16.293 5.293L12 9.586L7.99997 5.586L0.292969 13.293L1.70697 14.707L7.99997 8.414Z"
        fill="white"
      />
    </svg>
  );
};
